import { render, staticRenderFns } from "./updatePass.vue?vue&type=template&id=29fe61c4"
import script from "./updatePass.vue?vue&type=script&lang=js"
export * from "./updatePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports